import { warningDark } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
	className?: string;
	fillColor?: string;
}

export const UnsubscribeIcon: React.FC<IProps> = props => {
	const { className, fillColor, ...restProps } = props;
	return (
		<SvgIcon {...restProps} className={`unsubscribe-icon ${className || ''}`} height={18} width={18}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M13.5 7.5a2.96 2.96 0 01-1.514-.425l4.089-4.09c.264.447.425.96.425 1.515 0 1.654-1.345 3-3 3zm0-6a2.96 2.96 0 011.514.425l-4.089 4.09A2.96 2.96 0 0110.5 4.5c0-1.655 1.345-3 3-3zm0-1.5A4.505 4.505 0 009 4.5C9 6.982 11.018 9 13.5 9S18 6.982 18 4.5C18 2.019 15.982 0 13.5 0zm-12 16.5v-5.293l4.064 2.903a.749.749 0 00.872 0l4.064-2.903.002 5.293H1.5zm7.41-6L6 12.578 3.09 10.5h5.82zM10.5 9h-9C.673 9 0 9.673 0 10.5v6c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-6c0-.827-.673-1.5-1.5-1.5z'
				fill={warningDark || '#757575'}
			/>
		</SvgIcon>
	);
};
